import { useState } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

type Props = {
  className?: string;
  delayDisplayMs?: number;
};

const LoadingData = ({ className, delayDisplayMs = 2000 }: Props) => {
  // trigger after 2 seconds
  const [displayLoader, setDisplayLoader] = useState(false);

  if (!displayLoader) {
    setTimeout(() => {
      setDisplayLoader(true);
    }, delayDisplayMs);
    return null;
  }
  return (
    <div className={cn("flex w-full justify-center", className)}>
      <div className="relative h-20 w-20">
        {/* Outer Circle */}
        <div className="absolute h-full w-full animate-spin rounded-full border-4 border-[#09032F] border-t-transparent"></div>

        {/* Inner Circle */}
        <div className="animate-spin-slow absolute left-2 top-2 h-16 w-16 animate-spin-reverse rounded-full border-4 border-[#FFCCA9] border-t-transparent"></div>

        {/* Center Dot */}
        <div className="absolute h-6 w-6 animate-pulse rounded-full bg-[#8580FF] opacity-50"></div>
      </div>
    </div>
  );
};

export default LoadingData;
